var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183419_26520)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.0625C6.06562 2.0625 2.0625 6.06562 2.0625 11C2.0625 15.9344 6.06562 19.9375 11 19.9375C15.9344 19.9375 19.9375 15.9344 19.9375 11C19.9375 6.06562 15.9344 2.0625 11 2.0625ZM3.4375 11C3.4375 6.82501 6.82501 3.4375 11 3.4375C15.175 3.4375 18.5625 6.82501 18.5625 11C18.5625 15.175 15.175 18.5625 11 18.5625C6.82501 18.5625 3.4375 15.175 3.4375 11ZM11.6875 7.5625C11.6875 7.1828 11.3797 6.875 11 6.875C10.6203 6.875 10.3125 7.1828 10.3125 7.5625V10.3125H7.5625C7.1828 10.3125 6.875 10.6203 6.875 11C6.875 11.3797 7.1828 11.6875 7.5625 11.6875H10.3125V14.4375C10.3125 14.8172 10.6203 15.125 11 15.125C11.3797 15.125 11.6875 14.8172 11.6875 14.4375V11.6875H14.4375C14.8172 11.6875 15.125 11.3797 15.125 11C15.125 10.6203 14.8172 10.3125 14.4375 10.3125H11.6875V7.5625Z",
    fill: "#1890FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183419_26520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.21b0d17f4c3277106035560273577dff.svg";
export { ForwardRef as ReactComponent };